import React, { Component } from 'react';
import styleable from 'react-styleable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { DataTable } from '@3plearning/react-components';
import cloneDeep from 'lodash/cloneDeep';

import css from './all-classess.scss';

import {
    SELECTED_CLASS,
    ALL_CLASSES,
    SELECTED_DATE,
    SELECTED_YEAR_GROUP,
    SELECTED_TEACHER
} from '../../../components/report-filters/filter-constants';
import {
    CLASS_NAME,
    SKILL_QUESTS_MASTERY_LEGENDS_VARIANTS
} from '../skill-quests-mastery-constants';
import allClassTableConfig from './all-classes-constants';

import {
    alignAllClassesTableConfigBody,
    alignTableConfigHeader,
    manageTranslation,
    onInvalidRequest,
    translateTableContent
} from '../skill-quests-mastery-helpers';

import activeFiltersSelectors from '../../../components/report-filters/redux/active-filters/active-filters-selectors';
import FilterHelper from '../../../helpers/filter-helper';
import { activeFiltersPropType } from '../../../components/report-filters/filter-prop-types';

import allClassesActions, {
    SKILL_QUESTS_MASTERY_ALL_CLASSES_RETRIEVED
} from './all-classes-actions';
import exportReportActions from '../../../components/sub-heading/export-report/export-report-actions';
import activeFiltersActions from '../../../components/report-filters/redux/active-filters/active-filters-actions';

import SkillQuestsMasteryLegends from '../../../components/skill-quests-mastery-legends/skill-quests-mastery-legends';
import SubHeadingButtons from '../../../components/sub-heading/sub-heading-buttons/sub-heading-buttons';
import AssignmentResult from '../../../components/assignment-result/assignment-result';

/**
 * Skill Quests Mastery All Classes
 * Displays class level report
 */
export class AllClasses extends Component {
    static propTypes = {
        // redux filter values
        activeFilters: activeFiltersPropType,
        // Values for class filter
        classFilter: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
        // Download report handler
        downloadStudentReport: PropTypes.func,
        // Export report handler
        exportReport: PropTypes.func,
        // Is requesting download report
        isProcessingDownload: PropTypes.bool,
        // Manages active filter redux values
        updateActiveFilter: PropTypes.func,
        // BE Data for skill quests mastery all classes
        skillQuestsMasteryData: PropTypes.object,
        assignmentResultType: PropTypes.number,
        getSkillQuestsMasteryData: PropTypes.func
    };

    constructor(props) {
        super(props);

        this.state = {
            tableConfig: allClassTableConfig
        };
    }
    componentDidMount() {
        const { activeFilters } = this.props;
        if (FilterHelper.shouldLoadAllClasses(activeFilters)) {
            this.getAllClassesSkillQuestsMasteryData(this.props);
        }
    }

    componentWillReceiveProps(newProps) {
        this.onParamChange(this.props, newProps);
        this.onDataChange(this.props, newProps);
        onInvalidRequest(
            this.props,
            newProps,
            SKILL_QUESTS_MASTERY_ALL_CLASSES_RETRIEVED
        );
    }

    /**
     * ON PROPS CHANGE HANDLERS
     */
    onDataChange = (props, newProps) => {
        const { skillQuestsMasteryData } = props;
        const { skillQuestsMasteryData: newSkillQuestsMasteryData } = newProps;

        if (skillQuestsMasteryData !== newSkillQuestsMasteryData) {
            this.setTableConfig(newProps);
        }
    };

    onParamChange = (props, newProps) => {
        const { activeFilters, assignmentResultType } = props;
        const {
            activeFilters: newActiveFilters,
            assignmentResultType: newAssignmentResultType
        } = newProps;

        const shouldReload =
            FilterHelper.shouldReloadAllClasses(
                activeFilters,
                newActiveFilters
            ) || assignmentResultType !== newAssignmentResultType;

        if (shouldReload) {
            this.getAllClassesSkillQuestsMasteryData(newProps);
        }
    };

    getAllClassesSkillQuestsMasteryData = (props) => {
        const {
            activeFilters,
            getSkillQuestsMasteryData,
            assignmentResultType
        } = props;

        getSkillQuestsMasteryData(
            activeFilters[SELECTED_DATE],
            activeFilters[SELECTED_YEAR_GROUP].id,
            activeFilters[SELECTED_TEACHER].id,
            assignmentResultType
        );
    };

    /**
     * SETUP TABLE CONFIG
     */
    navigateToGroupLevel = (selectedItem) => {
        this.props.updateActiveFilter(SELECTED_CLASS, {
            id: selectedItem.classId,
            name: selectedItem.className
        });
    };

    tableConfigTranslations = (updatedTableConfig) => {
        const i18n = window.i18n;

        updatedTableConfig.cols.find(
            (col) => col.id === CLASS_NAME.id
        ).name = manageTranslation(CLASS_NAME, i18n);
        translateTableContent(i18n, updatedTableConfig);

        return updatedTableConfig;
    };

    setTableConfig = (props) => {
        const { skillQuestsMasteryData } = props;
        const i18n = window.i18n;

        let updatedTableConfig = cloneDeep(allClassTableConfig);

        if (skillQuestsMasteryData) {
            updatedTableConfig = alignTableConfigHeader(
                skillQuestsMasteryData,
                updatedTableConfig
            );
            updatedTableConfig = alignAllClassesTableConfigBody(
                updatedTableConfig,
                i18n
            );
            updatedTableConfig.cols.find(
                (col) => col.id === CLASS_NAME.id
            ).onClick = this.navigateToGroupLevel;
            updatedTableConfig = this.tableConfigTranslations(
                updatedTableConfig
            );
        }

        this.setState({
            tableConfig: updatedTableConfig
        });
    };

    /**
     * SUB HEADING BUTTONS HANDLERS
     */
    getIsDownloadEnabled = () => {
        const { classFilter } = this.props;
        const classFilterName = classFilter.name;

        return classFilterName !== '' && classFilterName !== ALL_CLASSES;
    };

    render() {
        const {
            downloadStudentReport,
            exportReport,
            isProcessingDownload,
            skillQuestsMasteryData
        } = this.props;
        const { tableConfig } = this.state;

        return (
            <div className={css['sqm-all-classes']}>
                <div className={css['sub-heading']}>
                    <div className={css['right-side']}>
                        <SkillQuestsMasteryLegends
                            variant={
                                SKILL_QUESTS_MASTERY_LEGENDS_VARIANTS.CLASS_GROUP_LEVEL
                            }
                        />
                        <AssignmentResult />
                        <SubHeadingButtons
                            isDownloadEnabled={this.getIsDownloadEnabled()}
                            isExportEnabled
                            isProcessingDownload={isProcessingDownload}
                            onExportReport={exportReport}
                            onDownloadReport={downloadStudentReport}
                        />
                    </div>
                </div>
                <div className={css['data-table']}>
                    {skillQuestsMasteryData && (
                        <DataTable
                            config={tableConfig}
                            data={skillQuestsMasteryData.classes}
                        />
                    )}
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        activeFilters: activeFiltersSelectors.selectActiveFilters(state),
        classFilter: activeFiltersSelectors.selectFilter(SELECTED_CLASS),
        invalidRequest: state.invalidRequest,
        isProcessingDownload: state.downloadReport.isProcessingDownload,
        skillQuestsMasteryData: state.skillQuestsMasteryAllClasses.data,
        assignmentResultType: state.assignmentResultType
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            downloadStudentReport: exportReportActions.downloadStudentReport,
            exportReport: exportReportActions.exportReport,
            getSkillQuestsMasteryData:
                allClassesActions.getSkillQuestsMasteryData,
            updateActiveFilter: activeFiltersActions.updateActiveFilter
        },
        dispatch
    );
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(styleable(css)(AllClasses));



// WEBPACK FOOTER //
// ./containers/skill-quests-mastery/all-classes/all-classes.js